export enum SearchTypeEnum {
    account = 'account',
    user = 'user',
    profil = 'profil',
    office = 'office',
    docteur = 'docteur',
    profilOffice = 'profil-office',
    role = 'role'
}
